import React, { useState, useEffect } from 'react';

import { adminGet, adminPost, adminDelete } from '../utils/requests';

import style from './SiteSettings.module.scss';

type Props = { siteId: string };

const NotificationSettings = ({ siteId }: Props): JSX.Element => {
  const [emails, setEmails] = useState<string[]>([]);
  const [newEmail, setNewEmail] = useState<string>('');
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    adminGet<any[]>(`/sites/${siteId}/notification_emails/`)
      .then(setEmails)
      .catch(setError);
  }, [siteId]);

  const removeEmail = (email: string) => {
    // TODO: make the request
    adminDelete(`/sites/${siteId}/notification_emails/${email}`)
      .then(() => setEmails(emails.filter(e => e !== email)))
      .catch(setError);
  };

  const addEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    adminPost(`/sites/${siteId}/notification_emails/`, {
      email: newEmail
    })
      .then(() => {
        setEmails([...emails, newEmail]);
        setNewEmail('');
      })
      .catch(setError);
  };
  return (
    <React.Fragment>
      <h2>Notifications</h2>
      <p>
        Also send new comment notifications to the following email addresses:
      </p>
      {!!error && <p className={style.error}>{error.message}</p>}
      <ul className={style.emailList}>
        {emails.map(email => (
          <li key={email}>
            {email}{' '}
            <button
              className={style.deleteEmail}
              onClick={() => removeEmail(email)}
            >
              ✗
            </button>
          </li>
        ))}
        <li>
          <form onSubmit={addEmail}>
            <input
              value={newEmail}
              onChange={e => setNewEmail(e.target.value)}
            />
            <button type="submit">Add</button>
          </form>
        </li>
      </ul>
    </React.Fragment>
  );
};

export default function SiteSettings(props: Props): JSX.Element {
  return (
    <div className={style.mainContent}>
      <NotificationSettings siteId={props.siteId} />
    </div>
  );
}
